export const noop = (): void => {};

export const isBoolean = (value: unknown): value is boolean =>
  typeof value === "boolean";
export const isString = (value: unknown): value is string =>
  typeof value === "string";
export const isNumber = (value: unknown): value is number =>
  typeof value === "number";
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const isFunction = (value: unknown): value is Function =>
  value instanceof Function;
export const isUndefined = (value: unknown): value is undefined =>
  value === undefined;

export const isEmptyValue = (value: unknown): boolean =>
  value === undefined || value === null || value === "";

export type DeepRequired<T> = {
  [K in keyof T]-?: T[K] extends object ? DeepRequired<T[K]> : T[K];
};
